import { IApproverDocumentModel, IApproverDocumentPostModel, IApproverFlowModel, IApproverFlowPostModel, IApproverFlowPutModel, IApproverUserModel } from "./model/IApproverModel";
import { DefaultResult, Result } from "./rest_api_connection/Result";
import { ServiceBase } from "./rest_api_connection/ServiceBase";

export default class ApproverService extends ServiceBase {

    public async getDocumentsMine(
        organizationId: string, onlyActive: boolean,
    ): Promise<Result<IApproverDocumentModel[]>> {
        let url = "/Organization/" + organizationId + "/Approver/Documents/Mine";

        if (onlyActive) {
            url = url + "?onlyActive=true";
        } else {
            url = url + "?onlyActive=false";
        }

        var result = await this.requestJson<IApproverDocumentModel[]>({
            url: url,
            method: "GET"
        });
        return result;
    }
    public async getDocumentsAll(
        organizationId: string, onlyActive: boolean,
    ): Promise<Result<IApproverDocumentModel[]>> {
        let url = "/Organization/" + organizationId + "/Approver/Documents/All";

        if (onlyActive) {
            url = url + "?onlyActive=true";
        } else {
            url = url + "?onlyActive=false";
        }

        var result = await this.requestJson<IApproverDocumentModel[]>({
            url: url,
            method: "GET"
        });
        return result;
    }
    public async getDocument(
        organizationId: string, documentId: number,
    ): Promise<Result<IApproverDocumentModel>> {
        let url = "/Organization/" + organizationId + "/Approver/Documents/" + documentId;

        var result = await this.requestJson<IApproverDocumentModel>({
            url: url,
            method: "GET"
        });
        return result;
    }

    public async postDocumentData(
        organizationId: string, documentId: number, data: IApproverDocumentPostModel
    ): Promise<DefaultResult> {
        let url = "/Organization/" + organizationId + "/Approver/Documents/" + documentId;

        var result = await this.requestJsonDefault({
            url: url,
            method: "POST",
            data: data
        })
        return result;
    }
    public async postDocumentApprove(
        organizationId: string, documentId: number, newUserId?: string
    ): Promise<DefaultResult> {
        let url = "/Organization/" + organizationId + "/Approver/Documents/" + documentId + "/Approve";

        if (newUserId && newUserId !== "") { 
            url = url + "?newUserId=" + newUserId
        }

        var result = await this.requestJsonDefault({
            url: url,
            method: "POST"
        });
        return result;
    }
    public async postDocumentReject(
        organizationId: string, documentId: number,
    ): Promise<DefaultResult> {
        let url = "/Organization/" + organizationId + "/Approver/Documents/" + documentId + "/Reject";

        var result = await this.requestJsonDefault({
            url: url,
            method: "POST"
        });
        return result;
    }
    public async postDocumentPostpone(
        organizationId: string, documentId: number,
    ): Promise<DefaultResult> {
        let url = "/Organization/" + organizationId + "/Approver/Documents/" + documentId + "/Postpone";

        var result = await this.requestJsonDefault({
            url: url,
            method: "POST"
        });
        return result;
    }
    public async postDocumentAssign(
        organizationId: string, documentId: number, newUserId?: string
    ): Promise<DefaultResult> {
        let url = "/Organization/" + organizationId + "/Approver/Documents/" + documentId + "/Assign";

        if (newUserId && newUserId !== "") {
            url = url + "?newUserId=" + newUserId
        }

        var result = await this.requestJsonDefault({
            url: url,
            method: "POST"
        });
        return result;
    }
    public async postDocumentSwitchFlow(
        organizationId: string, documentId: number, newFlowId?: number
    ): Promise<DefaultResult> {
        let url = "/Organization/" + organizationId + "/Approver/Documents/" + documentId + "/SwitchFlow";

        if (newFlowId) {
            url = url + "?newFlowId=" + newFlowId
        }

        var result = await this.requestJsonDefault({
            url: url,
            method: "POST"
        });
        return result;
    }
    public async postDocumentStartApproval(
        organizationId: string, documentId: number
    ): Promise<DefaultResult> {
        let url = "/Organization/" + organizationId + "/Approver/Documents/" + documentId + "/StartApproval";

        var result = await this.requestJsonDefault({
            url: url,
            method: "POST"
        });
        return result;
    }
    public async getApprovers(
        organizationId: string
    ): Promise<Result<IApproverUserModel[]>> {
        let url = "/Organization/" + organizationId + "/Approver/Approvers";

        var result = await this.requestJson<IApproverUserModel[]>({
            url: url,
            method: "GET"
        });
        return result;
    }
    public async postApproverReplace(
        organizationId: string, id: string, newUserId: string
    ): Promise<DefaultResult> {
        let url = "/Organization/" + organizationId + "/Approver/Approvers/" + id + "/Replace";

        var result = await this.requestJsonDefault({
            url: url,
            method: "POST",
            data: {newUserId: newUserId}
        });
        return result;
    }

    public async getApproverFlows(
        organizationId: string
    ): Promise<Result<IApproverFlowModel[]>> {
        let url = "/Organization/" + organizationId + "/Approver/Flows";

        var result = await this.requestJson<IApproverFlowModel[]>({
            url: url,
            method: "GET"
        });
        return result;
    }
    public async getApproverFlow(
        organizationId: string, id: number
    ): Promise<Result<IApproverFlowModel>> {
        let url = "/Organization/" + organizationId + "/Approver/Flows/" + id;

        var result = await this.requestJson<IApproverFlowModel>({
            url: url,
            method: "GET"
        });
        return result;
    }
    public async postApproverFlow(
        organizationId: string, id: number, data: IApproverFlowPostModel
    ): Promise<DefaultResult> {
        let url = "/Organization/" + organizationId + "/Approver/Flows/";

        var result = await this.requestJsonDefault({
            url: url,
            method: "POST",
            data: data
        });
        return result;
    }
    public async postApproverFlowsReorder(
        organizationId: string, flows: number[]): Promise<DefaultResult> {
        let url = "/Organization/" + organizationId + "/Approver/Flows/Reorder";

        var result = await this.requestJsonDefault({
            url: url,
            method: "POST",
            data: {flows: flows}
        });
        return result;
    }
    public async deleteApproverFlow(
        organizationId: string, id: number
    ): Promise<DefaultResult> {
        let url = "/Organization/" + organizationId + "/Approver/Flows/" + id;

        var result = await this.requestJsonDefault({
            url: url,
            method: "DELETE"
        });
        return result;
    }
    public async putApproverFlow(
        organizationId: string, id: number, data: IApproverFlowPutModel
    ): Promise<DefaultResult> {
        let url = "/Organization/" + organizationId + "/Approver/Flows/" + id;

        var result = await this.requestJsonDefault({
            url: url,
            method: "PUT",
            data: data
        });
        return result;
    }
    
}